import React from 'react'
import Modal from 'react-bootstrap/esm/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleCheck,
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

interface MarkCompletedModalProps {
  show: boolean
  contributorName: string
  assessmentName: string
  isSubmitting?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function MarkCompletedModal({
  show,
  contributorName,
  assessmentName,
  isSubmitting = false,
  onConfirm,
  onCancel,
}: MarkCompletedModalProps) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <div className="gw-mark-completed-modal">
        <div className="gw-mark-completed-header">
          <div className="gw-mark-completed-title-group">
            <div className="gw-mark-completed-icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <h3 className="gw-mark-completed-title">
              Mark Assessment as Completed
            </h3>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="gw-mark-completed-close"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <p className="gw-mark-completed-copy">
          Are you sure you want to mark{' '}
          <span className="fw-semibold">
            {contributorName}&apos;s {assessmentName}
          </span>{' '}
          assessment as completed?
        </p>

        <div className="gw-mark-completed-warning">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="gw-mark-completed-warning-icon"
          />
          <p>
            This will lock all scores and notes for this assessment. This
            action cannot be undone.
          </p>
        </div>

        <div className="gw-mark-completed-actions">
          <button
            type="button"
            onClick={onCancel}
            className="gw-btn-cancel"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="gw-btn-submit gw-btn-submit--success"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Completing...' : 'Mark as Completed'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
